import { editUserRequest } from 'application/core/data/api/user'

export const editUser = editUserRequest
